






































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { WorkerAnonModule } from '@/store/modules/workerAnon';
import AnonBookingRoleWorkerDto from '@/models/AnonBookingRoleWorkers/AnonBookingRoleWorkerDto';
import UpdateAnonWorkerBookingOfferRequest from '@/models/AnonBookingRoleWorkers/UpdateAnonWorkerBookingOfferRequest';
import PageNames from '@/router/PageNames';
import AnonOfferedReplyViewModel from '@/models/AnonBookingRoleWorkers/AnonOfferedReplyViewModel';
import ListUtils from '@/lib/listUtils';
import GiganautVueDialog from '@/components/Shared/GiganautVueDialog';
import ShiftDeclinedReason from '@/models/Shared/ShiftDeclinedReason';
import AnonOfferedReplyDto from '@/models/AnonBookingRoleWorkers/AnonOfferedReplyDto';
import BookingRoleWorkerShiftStatus from '@/models/BookingRoleWorkerShifts/BookingRoleWorkerShiftStatus';

@Component({
    name: 'WorkerBookingOfferApplyDecline'
})
export default class extends GiganautVueDialog {

  public dialog = false;
  public shifts: AnonOfferedReplyViewModel[] = [];
  
  @Watch('dialog')
  onDialogChanged(val: boolean, oldVal: boolean) {
    if (val) {
      this.shifts =  WorkerAnonModule.bookingOffer.shifts
      .filter(function(anonShiftSummaryDto) {
        return anonShiftSummaryDto.status === BookingRoleWorkerShiftStatus.Offered;
      }).map(function(anonShiftSummaryDto) {
        const shiftVM = new AnonOfferedReplyViewModel();
        shiftVM.bookingRoleWorkerShiftId = anonShiftSummaryDto.bookingRoleWorkerShiftId;
        shiftVM.startAt = anonShiftSummaryDto.startAt;
        shiftVM.endAt = anonShiftSummaryDto.endAt;
        return shiftVM;
      });
      //console.log(this.shifts);
    }
  }

  get loading() {
    return WorkerAnonModule.loadingDialog;
  }

  get declinedReasons() {
    return ListUtils.shiftDeclinedReasons();
  }
	  
  async submit() { 
     if (!(this.$refs.form as any).validate()) {
      return;
    }
    const request = new UpdateAnonWorkerBookingOfferRequest();
    request.updatedAt = WorkerAnonModule.bookingOffer.updatedAt
    request.replies = this.shifts.map(function(vm: AnonOfferedReplyViewModel) {
      const reply: AnonOfferedReplyDto = new AnonOfferedReplyDto();
      reply.bookingRoleWorkerShiftId = vm.bookingRoleWorkerShiftId;
      reply.applied = vm.apply;
      if (reply.applied) {
        reply.declinedReason = ShiftDeclinedReason.BOOKING_DECLINED_REASON_UNDEFINED;
      } else {
        reply.declinedReason = vm.declinedReason;
      }
      return reply;
    });
    await WorkerAnonModule.updateBookingOffer(request);
    this.dialog = false;
    if (WorkerAnonModule.isError) {
       this.$router.push({ name: PageNames.WorkerError });
    }
  }
}
